<template>
    <div class="mobile-login-page">
        <div class="login-card">
            <div class="logo-area">
                <img src="@/assets/logo.png" alt="logo" class="logo-img" />
                <div class="system-title">凌恩商务管理系统</div>
            </div>
            <van-form ref="loginForm" class="login-form" @submit.native.prevent label-width="60px">
                <van-field required v-model="loginForm.username" name="username" label="账号" placeholder="请输入用户名/手机号/邮箱"
                    :rules="[{ required: true, message: '不能为空' }]" />
                <van-field required v-model="loginForm.password" type="password" name="password" label="密码"
                    placeholder="请输入密码" :rules="[{ required: true, message: '不能为空' }]" />
                <van-field name="switch" label="记住我" class="remember-text">
                    <template #input>
                        <van-switch v-model="rememberUsernamePwd" size="15" active-color="#13ce66"
                            inactive-color="#ff4949" />
                    </template>
                </van-field>
                <div class="login-action">
                    <van-button round block type="info" size="small" :loading="loading" @click="submitForm">登录</van-button>
                </div>
            </van-form>
            <p class="hint"><i class="el-icon-info"></i> 温馨提示：为保障您的使用体验，请使用最新版 Chrome 浏览器进行访问。</p>
        </div>
    </div>
</template>

<script>
import { login } from "@/api/dilivery";
import { getDataInLocalStorage, removeDataInLocalStorage, saveDataToLocalStorage } from "@/utils/localStorage";
import { getEvaluators } from "@/api/dilivery/customer/person";
import { saveUserAccount } from "@/utils/jsencrypt";
import CryptoJS from 'crypto-js';
import { setModeFlag, isMobile } from "@/utils/index";

export default {
    name: "LoginM",
    data() {
        return {
            accountSaveKey: 'accountInfo',
            rememberUsernamePwd: true,
            loading: false,
            loginForm: {
                username: '',
                password: ''
            },
            loginRules: {
                username: [{ required: true, message: '不能为空', trigger: 'blur' }],
                password: [{ required: true, message: '不能为空', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        this.getUserInfoByUrl()
    },
    methods: {
        getUserInfoByUrl() {
            const param = this.$route.query
            let username = param.user
            let password = param.pwd
            const withCode = param.withCode
            if (withCode) {
                let accountInfo = CryptoJS.AES.decrypt(decodeURIComponent(withCode), "personal_accountInfo").toString(CryptoJS.enc.Utf8)
                if (accountInfo) {
                    accountInfo = JSON.parse(accountInfo)
                    username = accountInfo.username
                    password = accountInfo.password
                }
            }
            if (username && password) {
                removeDataInLocalStorage("token")
                this.$store.commit('right/setUser', '')
                this.loginForm = {
                    username: username,
                    password: password,
                }
            } else {
                this.getLocalStorage()
            }
        },
        getLocalStorage() {
            const accountJson = getDataInLocalStorage(this.accountSaveKey);
            if (accountJson) {
                const accountInfo = JSON.parse(accountJson);
                this.loginForm.username = accountInfo.username
                this.loginForm.password = accountInfo.password
            }
        },
        submitForm() {
            // vant 表单 validate 返回 Promise
            this.$refs.loginForm.validate().then(() => {
                this.login();
            }).catch(() => {
                // validation failed
            })
        },
        async login() {
            this.loading = true
            try {
                let userData = {
                    username: this.loginForm.username,
                    password: this.loginForm.password
                }
                let sendData = await saveUserAccount(userData, this.rememberUsernamePwd, this.accountSaveKey)
                sendData.original = false
                const res = await login(sendData)
                if (res && res.data && res.data.code === 200) {
                    saveDataToLocalStorage('uuid', res.data.data['personUuids'][0])
                    let targetRoute = '/salesContract'
                    const role = res.data.data['roles'][0]
                    setModeFlag(role)
                    if (isMobile()) {
                        targetRoute = 'Contract'
                    }else{
                        if (['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST'].includes(role)) {
                            targetRoute = '/contractCheck'
                        } else if (role === 'BUSINESS_COMMERCIAL') {
                            targetRoute = '/refundInfo'
                        } else if (['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES','AUDITOR'].includes(role)) {
                            targetRoute = '/salesContract';
                        } else if (['FINANCE', 'CASHIER'].includes(role)) {
                            targetRoute = '/paymentInfo';
                        } else if (['LAB', 'TECH'].includes(role)) {
                            targetRoute = '/lexicon'
                        } else if (['ANALYSE'].includes(role)) {
                            targetRoute = '/template'
                        }
                    }
                    this.$message.success("登录成功!");
                    await this.saveUserInfo(res, targetRoute)
                } else {
                    this.$message.error(res.data ? res.data.message : '登录失败');
                    this.loginForm.password = ''
                }
            } catch (e) {
                console.error(e)
            } finally {
                this.loading = false
            }
        },
        async saveUserInfo(res, targetRoute) {
            try {
                this.$store.commit("right/setRole", res.data.data['roles'][0])
                this.$store.commit("right/setToken", res.headers.authorization)
                let userInfo = { ...res.data.data }
                this.$store.commit("right/setUser", JSON.stringify(userInfo))
                this.$store.commit("right/setReminder", false)
                this.$store.commit("right/setRoleLit", res.data.data['roles'])
                // saveDataToLocalStorage('EVALUATORS', false)
                // const response = await getEvaluators()
                // if (response.code === 200) {
                //     if (response.data.map(item => item.name).includes(res.data.data['realName']) || ['ADMIN', 'MANAGER'].includes(res.data.data['roles'][0])) {
                //         saveDataToLocalStorage('EVALUATORS', true)
                //     }
                // }
                await this.$router.push(targetRoute);
            } catch (error) {
                console.log(error);
            } finally {
                window.location.reload();
            }
        }
    }
}
</script>

<style scoped>
.mobile-login-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    padding: 20px;
    box-sizing: border-box;
}

.login-card {
    width: 100%;
    max-width: 420px;
    background: #fff;
    border-radius: 8px;
    padding: 18px;
    padding-bottom: calc(18px + constant(safe-area-inset-bottom));
    padding-bottom: calc(18px + env(safe-area-inset-bottom));
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}

.logo-area {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 12px;
}

.logo-img {
    height: 40px;
    width: 40px;
    object-fit: contain;
}

.system-title {
    font-size: 18px;
    color: #333;
    font-weight: 600;
}

.login-form {
    margin-top: 6px;
}

.remember-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 12px 0;
    gap: 8px;
}

.remember-left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.remember-text {
    font-size: 14px;
    color: #666;
}

.hint {
    margin-top: 12px;
    font-size: 12px;
    color: #9b9b9f;
    text-align: center;
}
</style>
